import { Component, OnInit } from '@angular/core';

import { AppService } from '../../services/app.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-index-jub',
  templateUrl: '../../pages/index/index.component.html',
  styleUrls: ['../../pages/index/index.component.css']
})
export class IndexJubComponent implements OnInit 
{
    options = { autoClose: true, keepAfterRouteChange: false };
    mensaje: boolean = false;
    refreshed : boolean = false;
    mensajeError: string;
    nombreUsuario: string = localStorage.getItem("nombreUsuario");

    constructor(private appService: AppService,private location: Location, public router: Router,  private loginService:LoginService) { }

    ngOnInit(): void  
    { 
     
      if (localStorage.getItem("refreshed")=='true') {   
          localStorage.setItem('refreshed', 'false');    
          location.reload();
      }
      this.loginService.traeDocumentos().then(response => console.log(response)).catch(error=>console.log(error));
    }
}
